var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"btn-link",attrs:{"href":_vm.url,"target":"_blank","disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[_c('span',{staticClass:"title-button"},[_vm._v(_vm._s(_vm.text))]),_c('img',{staticClass:"icon",attrs:{"src":_vm.iconButton}})])
}
var staticRenderFns = []

export { render, staticRenderFns }